export default __webpack_public_path__ + "static/media/view.d008528b.svg";